<div style="width: 100%;padding-left: 10px;padding-right: 10px;display: flex;flex-direction:column;gap: 10px;">
    <div class="card-pill">
        {{currentTag}}
    </div>
    <div style="width: 100%;">
        <p *ngIf="strengthsPoints && strengthsPoints.length" style="color: #001E60;font-size: large;">
            <b>{{ 'aiSummary.SelectTagStrengths' | translate }}</b>
        </p>
        <div [ngClass]="isExportMode ? 'points-container-export' : 'points-container'">
            <div *ngFor="let point of strengthsPoints" class="points-container-border">

                <div class="profile-details-container">
                    <div class="profile-details">
                        <img *ngIf="point.reviewer && point.reviewer.imageUrl"
                            [src]="getImageUrl(point.reviewer.imageUrl)" />
                        <img *ngIf="!point.reviewer || !point.reviewer.imageUrl"
                            src="/assets/imgs/user-image-placeholder.png" />
                    </div>

                    <span style="font-weight: bold;">{{point.reviewer? (point.reviewer.name || '-'): 'No reviwer found'}}</span>
                    <ion-icon slot="icon-only" class="ellipse" src="/assets/icon/Ellipse5.svg"></ion-icon>
                    <span>{{point.reviewer? (point.reviewer.rank || '-') : '-'}}</span>
                    <ion-icon slot="icon-only" class="ellipse" src="/assets/icon/Ellipse5.svg"></ion-icon>
                    <span>{{point.reviewer? (point.reviewer.businessGroup || '-') : '-'}}</span>
                    <ion-icon slot="icon-only" class="ellipse" src="/assets/icon/Ellipse5.svg"></ion-icon>
                    <span>{{getProcessTypeName(point.process_type)}}</span>
                </div>
                <div>
                    <p>{{point.text || '-'}}</p>
                </div>
            </div>
        </div>

    </div>
    <div style="width: 100%;">
        <p *ngIf="weaknessesPoints && weaknessesPoints.length" style="color: #D1254C;font-size: large;">
            <b>{{ 'aiSummary.SelectTagPointsTodevelop' | translate }}</b>
        </p>
        <div [ngClass]="isExportMode ? 'points-container-export' : 'points-container'">
            <div *ngFor="let point of weaknessesPoints" class="points-container-border">

                <div class="profile-details-container">
                    <div class="profile-details">
                        <img *ngIf="point.reviewer && point.reviewer.imageUrl"
                            [src]="getImageUrl(point.reviewer.imageUrl)" />
                        <img *ngIf="!point.reviewer || !point.reviewer.imageUrl"
                            src="/assets/imgs/user-image-placeholder.png" />
                    </div>

                    <span style="font-weight: bold;">{{point.reviewer? (point.reviewer.name || '-'): 'No reviwer found'}}</span>
                    <ion-icon slot="icon-only" class="ellipse" src="/assets/icon/Ellipse5.svg"></ion-icon>
                    <span>{{point.reviewer? (point.reviewer.rank || '-') : '-'}}</span>
                    <ion-icon slot="icon-only" class="ellipse" src="/assets/icon/Ellipse5.svg"></ion-icon>
                    <span>{{point.reviewer? (point.reviewer.businessGroup || '-') : '-'}}</span>
                    <ion-icon slot="icon-only" class="ellipse" src="/assets/icon/Ellipse5.svg"></ion-icon>
                    <span>{{getProcessTypeName(point.process_type)}}</span>
                </div>
                <div>
                    <p>{{point.text || '-'}}</p>
                </div>
            </div>
        </div>
    </div>
</div>